'use strict'


const _TROY_OZ_TO_GRAM = 31.1035;

const ENDPOINT = 'latest';
const PARAMS = '?base=USD&codes=EUR';

function getGoldPrice() {
  const goldPriceWrappers = document.querySelectorAll('.gold-price-wrapper');
  if (!goldPriceWrappers.length) return;

  async function getUsdEurData() {
    try {
      const response = await fetch('https://currencyrateapi.com/api/' + ENDPOINT + PARAMS);

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const data = await response.json();

      return data;

    } catch (error) {
      console.error('Request Error::', error);
      return null;
    }
  }

  async function goldPrice() {
    try {
      const response = await fetch('https://api.gold-api.com/price/XAU');

      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }

      const data = await response.json();

      return data;

    } catch (error) {
      console.error(error);
      return {
        error: 'Could not fetch current gold price'
      };
    }
  }

  (async () => {
    const resultUsdEurDataUsdEurData = await getUsdEurData();
    const resultGoldPrice = await goldPrice();

    const usdEurRate = resultUsdEurDataUsdEurData.rates.eur;
    const priceInEurPerGram = (resultGoldPrice.price * usdEurRate) / _TROY_OZ_TO_GRAM;

    goldPriceWrappers.forEach(wrapper => {

      const INNER_ARR = [
        { container: wrapper.querySelector('[data-role="usd-eur"]>p'), innerData: usdEurRate },
        { container: wrapper.querySelector('[data-role="main-price-last-update"]>p'), innerData: formatDate(new Date()) }, // * resultGoldPrice.updatedAt
        { container: wrapper.querySelector('[data-role="gold-main-price"]>p'), innerData: formatCurrency(priceInEurPerGram) },
        { container: wrapper.querySelector('[data-role="gold-18k-price"]>p'), innerData: formatCurrency(priceInEurPerGram * 0.71) },
        { container: wrapper.querySelector('[data-role="gold-14k-price"]>p'), innerData: formatCurrency(priceInEurPerGram * 0.5169) }
      ];

      INNER_ARR.forEach(({ container, innerData }) => {
        if (container) container.innerHTML = `<span class="big-data">${innerData}</span>`;
      });
    });

  })();

  function formatCurrency(value) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat('de-DE', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  }

  setInterval(() => {
    getGoldPrice();
  }, 270000);
}
document.addEventListener('DOMContentLoaded', getGoldPrice);
document.addEventListener('shopify:section:load', getGoldPrice);
